<mat-sidenav-container class="sidenav-container" #sidenavContainer>
  <mat-sidenav
    #drawer
    fixedInViewport
    class="sidenav"
    position="start"
    [attr.role]="isHandset ? 'dialog' : 'navigation'"
    [attr.color]="'primary'"
    [mode]="isHandset ? 'over' : 'side'"
    [ngClass]="{ 'sidenav-collapsed': collapsed }"
    [opened]="!isHandset"
    (closed)="emitSidenavToggled()"
    (opened)="emitSidenavToggled()">
    <loren-sidenav
      class="loren-sidenav"
      [collapsed]="collapsed"
      (navMenuClicked)="drawer.close()"
      (toggleClicked)="toggleSidenav()"></loren-sidenav>
  </mat-sidenav>

  <mat-sidenav-content #content cdkScrollable class="loren-content">
    <loren-impersonation-banner />
    <loren-toolbar
      #lorenToolbar
      [drawer]="drawer"
      [isHandset]="isHandset"
      [isTablet]="isTablet">
    </loren-toolbar>
    <ng-content></ng-content>
  </mat-sidenav-content>

  <mat-sidenav
    #notifications
    fixedInViewport
    class="notifications-panel"
    [opened]="(detailsOutletState$ | async).visible"
    [position]="'end'"
    [style.width.%]="(detailsOutletState$ | async).width"
    (openedChange)="handleNotificationsOpened($event)">
    <ng-content select="[contextualOutlet]"></ng-content>
  </mat-sidenav>
</mat-sidenav-container>
